import React from "react";
import { ListGroup } from "react-bootstrap";
import { useConversations } from "../contexts/ConversationsProvider";
import { DOMAIN } from "../utils";
import { useContacts } from "../contexts/ContactsProvider";
import avatar from "../../assets/img/default-avatar.png";
import avatar2 from "../../assets/img/logorote.png";

export default function Conversations({ id }) {
  const { conversations, selectConversationIndex } = useConversations();
  const { contacts } = useContacts();

  function findContactProfileById(id) {
    const contact = contacts.find((contact) => contact.id === id);
    return contact ? contact.profile : undefined;
  }

  function countUnreadMessages(messages) {
    let unreadCount = 0;

    messages.forEach((message) => {
      if (!message.readStatus && message.sender !== id) {
        unreadCount++;
      }
    });

    return unreadCount;
  }

  return (
    <ListGroup variant="flush" style={{ padding: "10px 0" }}>
      {conversations.map((conversation, index) => {
        const unreadCount = countUnreadMessages(conversation.messages);
        return (
          <ListGroup.Item
            key={index}
            action
            onClick={() => selectConversationIndex(index)}
            active={conversation.selected}
            style={{
              border: "none",
              borderBottom: "1px solid #f0f0f0",
              padding: "15px 20px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: conversation.selected ? "#f0f4ff" : "#ffffff",
              borderRadius: "0",
            }}
            onMouseEnter={(e) => {
              if (!conversation.selected) {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.paddingLeft = "25px";
              }
            }}
            onMouseLeave={(e) => {
              if (!conversation.selected) {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.paddingLeft = "20px";
              }
            }}
          >
            {conversation.recipients.length > 1 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    marginRight: 12,
                  }}
                >
                  <img
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #e9ecef",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      display: "block",
                    }}
                    src={avatar2}
                    alt="group"
                    onError={(e) => {
                      e.target.src = avatar;
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      width: 16,
                      height: 16,
                      borderRadius: 8,
                      backgroundColor: "#28a745",
                      border: "2px solid white",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: "15px",
                        color: conversation.selected ? "#667eea" : "#2c3e50",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {conversation.nama}
                    </span>
                    {unreadCount > 0 && (
                      <div
                        style={{
                          backgroundColor: "#fd5c63",
                          color: "white",
                          minWidth: 20,
                          height: 20,
                          borderRadius: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "0 6px",
                          fontSize: "11px",
                          fontWeight: 600,
                          boxShadow: "0 2px 6px rgba(253, 92, 99, 0.4)",
                        }}
                      >
                        {unreadCount > 99 ? "99+" : unreadCount}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    marginRight: 12,
                  }}
                >
                  <img
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #e9ecef",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      display: "block",
                    }}
                    src={
                      findContactProfileById(conversation.recipients[0].id) &&
                      findContactProfileById(conversation.recipients[0].id) !==
                        "-"
                        ? DOMAIN +
                          findContactProfileById(conversation.recipients[0].id)
                        : avatar
                    }
                    alt="contact"
                    onError={(e) => {
                      e.target.src = avatar;
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      width: 16,
                      height: 16,
                      borderRadius: 8,
                      backgroundColor: "#28a745",
                      border: "2px solid white",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: "15px",
                        color: conversation.selected ? "#667eea" : "#2c3e50",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {conversation.recipients[0].name}
                    </span>
                    {unreadCount > 0 && (
                      <div
                        style={{
                          backgroundColor: "#fd5c63",
                          color: "white",
                          minWidth: 20,
                          height: 20,
                          borderRadius: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "0 6px",
                          fontSize: "11px",
                          fontWeight: 600,
                          boxShadow: "0 2px 6px rgba(253, 92, 99, 0.4)",
                        }}
                      >
                        {unreadCount > 99 ? "99+" : unreadCount}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
}
